module.exports = __webpack_public_path__ + "static/media/virus.d72f00d4.png";